<template>
  <div class="mw-panel">
    <toolbar-table ref="viewToolbarTable" :pagination="pagination" :limit="limit" :layout="layout">
    </toolbar-table>
  </div>
</template>

<script>
  export default {
    name: "component-revision",
    props: {
      componentId: String
    },
    data() {
      return {
        pagination: true,
        limit: 30,
        layout: [],
        form: {}
      }
    },
    mounted: function () {
      this._setLayout();
    },
    watch: {
      componentId(val, oval) {
        this._setLayout();
      }
    },
    methods: {
      _setLayout(){
        var me = this;
        me.layout =
          [
            [{
              key: 'page',
              type: 'menu',
              defaultActive: true,
              pagination: false,
              label: '组件历史版本',
              api: '/s:comp.srv.listComponentRevision',
              defaultParams: {componentId: me.componentId},
              defaultSort: [{sort: 'createTime', dir: 'desc'}],
              columns: [
                {type: 'selection'},
                {prop: 'name', tooltip: true, label: '名称'},
                {prop: 'revisionComment', tooltip: true, label: '类型',width:80,align:"center"},
                {prop: 'revisionUser', label: '最后修改者', width: 120,align:"center"},
                {prop: 'revisionTime', label: '最后修改时间', width: 180,align:"center"}
              ]
            }, {
              span: 16, type: 'button', items: [
                {label: '回滚', icon: "fa fa-plus-square", func: me.revertComponent},
              ]
            }]
          ]
      },

      loadData() {
        let dataTable=this.$refs.viewToolbarTable.$refs.dataTable;
        if(dataTable)dataTable.loadData();
      },
      revertComponent() {
        let me=this;
        let records=me.$refs.viewToolbarTable.getMultipleSelection()
        if(!records || records.length===0)return PF.message("请选择要回滚的版本");
        if(!records.length>1) return PF.message("只能选择一个回滚的版本");
        let id=records[0].id;
        PF.fsrv("comp.srv.revertComponent", [id]).then(res => {
          me.loadData();
          me.$emit("revert",res);
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/index/views/componentRevision/index.vue